import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import { Button } from '@spotnana/pixel-react/dist/Button';
import { useTranslation } from 'react-i18next';

interface IProps {
  onClose: () => void;
  isLoading?: boolean;
  onContinue?: () => void;
}

const PolicyModalFooter = ({ onClose, isLoading, onContinue }: IProps): JSX.Element => {
  const { t: tt } = useTranslation('WEB');

  const handleModalClose = (): void => {
    onClose();
  };

  return (
    <Box data-testid="modal-actions">
      <Flex height={60}>
        <Button variation="secondary" mr={20} block onClick={handleModalClose}>
          {tt('Back to search')}
        </Button>
        <Button block onClick={onContinue}>
          {tt('Proceed anyway')}
        </Button>
      </Flex>
    </Box>
  );
};

export default PolicyModalFooter;
